import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

import { navigateTo } from '../lib/navigation';

const FormsContext = createContext(null);
const formKeys = ['satici', 'alici', 'kiraya-veren', 'kiralayan'];
function blogEntry() {
  const params = new URLSearchParams(window.location.search || '');
  const form = params.get('form'), source = params.get('source') || '';
  return formKeys.includes(form) ? {form, source: /^[a-zA-Z0-9:_-]{1,160}$/.test(source) ? source : 'direct', motivation: params.get('mode') === 'motivation'} : null;
}

export function FormsProvider({ children }) {
  const [motivationRequest, setMotivationRequest] = useState(() => blogEntry()?.motivation ? {key: blogEntry().form, id: 1} : null);
  const [activeForm, setActiveForm] = useState(() => blogEntry()?.form || 'satici');
  const [formSource, setFormSource] = useState(() => ({ button_source: blogEntry()?.source || 'direct', form_type: blogEntry()?.form || 'satici' }));

  useEffect(() => { if (blogEntry()) document.getElementById('analiz')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, []);

  const openForm = useCallback((key, source = 'direct') => {
    if (key) setActiveForm(key);
    setFormSource({ button_source: source, form_type: key || activeForm });
    const el = document.getElementById('analiz');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else navigateTo(`/ihtiyac-analizi/?form=${encodeURIComponent(key || activeForm)}&source=${encodeURIComponent(source)}`);
  }, [activeForm]);

  const startMotivation = useCallback((key) => {
    setActiveForm(key);
    setFormSource({ button_source: `motivasyon-${key}`, form_type: key });
    setMotivationRequest({ key, id: Date.now() });
    const el = document.getElementById('analiz');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else navigateTo(`/ihtiyac-analizi/?form=${encodeURIComponent(key)}&mode=motivation&source=motivasyon-${key}`);
  }, []);

  return (
    <FormsContext.Provider value={{ activeForm, setActiveForm, openForm, formSource, setFormSource, motivationRequest, startMotivation }}>
      {children}
    </FormsContext.Provider>
  );
}

export function useForms() {
  const ctx = useContext(FormsContext);
  if (!ctx) throw new Error('useForms must be used within FormsProvider');
  return ctx;
}
